module.exports = __webpack_public_path__ + "static/media/warning_sign.e473158c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/warning_sign.svg
// module id = 623
// module chunks = 1